import {createFeatureSelector, createSelector} from "@ngrx/store";
import {caseEntitesFeatureKey, CaseEntitiesState} from "../reducers/case-entities.reducer";

const caseEntitesFeatureState = createFeatureSelector<CaseEntitiesState>(caseEntitesFeatureKey);

export const getCaseEntities = createSelector(
  caseEntitesFeatureState,
  state => state.caseEntities ?? []
);

export const getSelectedCaseEntityId = createSelector(
  caseEntitesFeatureState,
  state => state.selectedCaseEntityId ?? ""
);

export const getSelectedCaseEntity = createSelector(
  caseEntitesFeatureState,
  state => state.selectedCaseEntity ?? null
);

export const selectShowEditForm = createSelector(
  caseEntitesFeatureState,
    state => state.showEditForm
);
